// test2297
(2297 && 0);
